<template>
	<div>
		<!--单张图片上传-->
		<div v-if="fileNum == 1">
			<el-upload class="avatar-uploader" 
				action="/api/uploads" 
				:show-file-list="false" 
				:on-success="handleAvatarSuccess" 
				:before-upload="handleBeforeAvatarUpload">
					<img v-if="fileUrl" :src="fileUrl" class="avatar">
					<i v-else class="el-icon-plus avatar-uploader-icon"></i>
			</el-upload>
		</div>
		<!--多张图片上传-->
		<div v-else>
			<el-upload
			  action="/api/uploads"
			  list-type="picture-card"
			  :file-list="imgList"
			  :on-success="handleAvatarSuccess" 
			  :before-upload="handleBeforeAvatarUpload"
			  :on-preview="handlePictureCardPreview"
			  :on-remove="handleRemove"
			  :disabled=disabled>
			  <i class="el-icon-plus"></i>
			</el-upload>
			<el-dialog v-model="dialogVisible" size="tiny">
			  <img width="100%" :src="dialogImageUrl" alt="">
			</el-dialog>
		</div>
	</div>
</template>

<style lang="scss" >
	.avatar-uploader .el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	  }
	  .avatar-uploader .el-upload:hover {
	    border-color: #20a0ff;
	  }
	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    width: 100px;
	    height: 100px;
	    line-height: 100px;
	    text-align: center;
	  }
	  .avatar {
	    width: 100px;
	    height: 100px;
	    display: block;
	  }
</style>
<script>
	/**
	 * z-upload
	 * @module components/custom/Upload.vue
	 * @desc 搜索组件
	 * @param {Number} [file-num] - 允许传多少张，不传则默认一张
	 * @param {String} [fileUrl] - 上传单张
	 * @param {Array} [fileList] - 上传多张
	 * @example
	 * <z-upload :file-num =2 :file-url='fileUrl' :file-list = 'fileList'></z-upload>
	 * 
	 */
	import loading from "@/utils/loading.js"
	export default {
		name: 'z-upload',
		data() {
			return {
				dialogImageUrl: '',
        		dialogVisible: false,
        		disabled:false,
        		imgList :[]
			}
		},
		props: {
			fileNum: {
	    		type:Number,
				default: 1
	   		},
	   		onSuccess: Function,
	   		fileUrl: {
	    		type:String,
				default: ''
   			},
   			fileList: {
		        type: Array,
		        default() {
		          return [];
		        }
		      }
		},
		mounted() {
			if(this.fileNum > 1){
				this.fileList.map((item,index)=>{
					this.imgList.push({name:index,url:item})
				})
			}
		},
		watch :{//监听数据变化
    		fileList(val){
    			this.imgList = []
    			val.map((item,index)=>{
    				this.imgList.push({name:index,url:item})
				})
    		}
	  	},
		methods: {
			handleAvatarSuccess(res, file) {
				loading.pop()
				if(file.response.code == 0) {
					let url = file.response.data.url
					this.onSuccess(url)
				}else{
					this.$errorMsg('上传失败');	
				}
			},
			handleBeforeAvatarUpload(file) {
				if(this.imgList.length >= this.fileNum) return this.$warning(`最多上传 ${this.fileNum} 张图片`);
				const isJPG = file.type === 'image/jpeg'
				const isPNG = file.type === 'image/png'
				const isLtSize = file.size / 1024 / 1024 < 2
				if(!(isJPG || isPNG)) {
					this.$warning('上传图片只能是 JPG或者PNG 格式!');
				}
				if(!isLtSize) {
					this.$warning('上传图片大小不能超过 2M!');
				}
				loading.put()
				return isLtSize && (isJPG || isPNG);
			},
			handleRemove(file, fileList) {
	        	let index = this.fileList.indexOf(file.url)
	        	this.fileList.splice(index,1)
	      	},
	      	handlePictureCardPreview(file) {
	        	this.dialogImageUrl = file.url;
	        	this.dialogVisible = true;
	      	}
		}
	}
</script>


// WEBPACK FOOTER //
// Upload.vue?2758b04d